import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

import { IShareLivePeople, defaultValue } from 'app/shared/model/share-live-people.model';
// 请求
export const ACTION_TYPES = {
  FETCH_SHARELIVEPEOPLE_LIST: 'shareLivePeople/FETCH_SHARELIVEPEOPLE_LIST',
  FETCH_SHARELIVEPEOPLE: 'shareLivePeople/FETCH_SHARELIVEPEOPLE',
  CREATE_SHARELIVEPEOPLE: 'shareLivePeople/CREATE_SHARELIVEPEOPLE',
  UPDATE_SHARELIVEPEOPLE: 'shareLivePeople/UPDATE_SHARELIVEPEOPLE',
  DELETE_SHARELIVEPEOPLE: 'shareLivePeople/DELETE_SHARELIVEPEOPLE',
  RESET: 'shareLivePeople/RESET'
};
// state
const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IShareLivePeople>,
  entity: defaultValue,
  updating: false,
  updateSuccess: false
};

export type ShareLivePeopleState = Readonly<typeof initialState>;

// Reducer

export default (state: ShareLivePeopleState = initialState, action): ShareLivePeopleState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_SHARELIVEPEOPLE_LIST):
    case REQUEST(ACTION_TYPES.FETCH_SHARELIVEPEOPLE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true
      };
    case REQUEST(ACTION_TYPES.CREATE_SHARELIVEPEOPLE):
    case REQUEST(ACTION_TYPES.UPDATE_SHARELIVEPEOPLE):
    case REQUEST(ACTION_TYPES.DELETE_SHARELIVEPEOPLE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true
      };
    case FAILURE(ACTION_TYPES.FETCH_SHARELIVEPEOPLE_LIST):
    case FAILURE(ACTION_TYPES.FETCH_SHARELIVEPEOPLE):
    case FAILURE(ACTION_TYPES.CREATE_SHARELIVEPEOPLE):
    case FAILURE(ACTION_TYPES.UPDATE_SHARELIVEPEOPLE):
    case FAILURE(ACTION_TYPES.DELETE_SHARELIVEPEOPLE):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload
      };
    case SUCCESS(ACTION_TYPES.FETCH_SHARELIVEPEOPLE_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.FETCH_SHARELIVEPEOPLE):
      return {
        ...state,
        loading: false,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.CREATE_SHARELIVEPEOPLE):
    case SUCCESS(ACTION_TYPES.UPDATE_SHARELIVEPEOPLE):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.DELETE_SHARELIVEPEOPLE):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {}
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

const apiUrl = 'api/share-live-people';

// Actions

export const getEntities: ICrudGetAllAction<IShareLivePeople> = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_SHARELIVEPEOPLE_LIST,
  payload: axios.get<IShareLivePeople>(`${apiUrl}?cacheBuster=${new Date().getTime()}`)
});

export const getEntity: ICrudGetAction<IShareLivePeople> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_SHARELIVEPEOPLE,
    payload: axios.get<IShareLivePeople>(requestUrl)
  };
};

export const createEntity: ICrudPutAction<IShareLivePeople> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_SHARELIVEPEOPLE,
    payload: axios.post(apiUrl, cleanEntity(entity))
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IShareLivePeople> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_SHARELIVEPEOPLE,
    payload: axios.put(apiUrl, cleanEntity(entity))
  });
  dispatch(getEntities());
  return result;
};

export const deleteEntity: ICrudDeleteAction<IShareLivePeople> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_SHARELIVEPEOPLE,
    payload: axios.delete(requestUrl)
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET
});
